import React, { createContext, useContext } from "react";

import { ChangelogEntry } from "@/queries/folder-entities/types";

const ChangelogItemContext = createContext<ChangelogEntry | null>(null);

export const useEvent = <T extends ChangelogEntry = ChangelogEntry>() => {
  const context = useContext(ChangelogItemContext);
  if (!context) {
    throw new Error("useEvent must be used within ChangelogItemProvider");
  }
  return {
    ...context,
  } as T & { isPending: boolean };
};

interface ChangelogItemProviderProps {
  event: ChangelogEntry;
  children: React.ReactNode;
}

export const ChangelogItemProvider = ({ event, children }: ChangelogItemProviderProps) => (
  <ChangelogItemContext.Provider value={event}>{children}</ChangelogItemContext.Provider>
);
